import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./utils/axios.tool"
import './assets/fonts/iconfont.css';
import './utils/btnPermissions'

import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts



Vue.use(ElementUI);

Vue.config.productionTip = false
import './assets/icon/iconfont.css';
// import '@/styles/index.scss'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
